/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Measurement } from './Measurement';
import type { Language } from './Language';
import type { SessionDefinition } from './SessionDefinition';
/**
 * 
 * @export
 * @interface MeasurementDefinition
 */
export interface MeasurementDefinition {
    /**
     * 
     * @type {number}
     * @memberof MeasurementDefinition
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MeasurementDefinition
     */
    languageCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeasurementDefinition
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeasurementDefinition
     */
    sessionDefinitionId?: number;
    /**
     * 
     * @type {string}
     * @memberof MeasurementDefinition
     */
    audioTrack?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeasurementDefinition
     */
    exampleRecording?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeasurementDefinition
     */
    data?: string | null;
    /**
     * 
     * @type {Language}
     * @memberof MeasurementDefinition
     */
    languageCodeNavigation?: Language;
    /**
     * 
     * @type {Array<Measurement>}
     * @memberof MeasurementDefinition
     */
    measurements?: Array<Measurement> | null;
    /**
     * 
     * @type {SessionDefinition}
     * @memberof MeasurementDefinition
     */
    sessionDefinition?: SessionDefinition;
}

/**
 * Check if a given object implements the MeasurementDefinition interface.
 */
export function instanceOfMeasurementDefinition(value: object): value is MeasurementDefinition {
    return true;
}

export function MeasurementDefinitionFromJSON(json: any): MeasurementDefinition {
    return MeasurementDefinitionFromJSONTyped(json, false);
}

export function MeasurementDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeasurementDefinition {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'languageCode': json['languageCode'] == null ? undefined : json['languageCode'],
        'name': json['name'] == null ? undefined : json['name'],
        'sessionDefinitionId': json['sessionDefinitionId'] == null ? undefined : json['sessionDefinitionId'],
        'audioTrack': json['audioTrack'] == null ? undefined : json['audioTrack'],
        'exampleRecording': json['exampleRecording'] == null ? undefined : json['exampleRecording'],
        'data': json['data'] == null ? undefined : json['data'],
        'languageCodeNavigation': json['languageCodeNavigation'] == null ? undefined : (require('./Language') as typeof import('./Language')).LanguageFromJSON(json['languageCodeNavigation']),
        'measurements': json['measurements'] == null ? undefined : ((json['measurements'] as Array<any>).map((require('./Measurement') as typeof import('./Measurement')).MeasurementFromJSON)),
        'sessionDefinition': json['sessionDefinition'] == null ? undefined : (require('./SessionDefinition') as typeof import('./SessionDefinition')).SessionDefinitionFromJSON(json['sessionDefinition']),
    };
}

export function MeasurementDefinitionToJSON(json: any): MeasurementDefinition {
    return MeasurementDefinitionToJSONTyped(json, false);
}

export function MeasurementDefinitionToJSONTyped(value?: MeasurementDefinition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'languageCode': value['languageCode'],
        'name': value['name'],
        'sessionDefinitionId': value['sessionDefinitionId'],
        'audioTrack': value['audioTrack'],
        'exampleRecording': value['exampleRecording'],
        'data': value['data'],
        'languageCodeNavigation': (require('./Language') as typeof import('./Language')).LanguageToJSON(value['languageCodeNavigation']),
        'measurements': value['measurements'] == null ? undefined : ((value['measurements'] as Array<any>).map((require('./Measurement') as typeof import('./Measurement')).MeasurementToJSON)),
        'sessionDefinition': (require('./SessionDefinition') as typeof import('./SessionDefinition')).SessionDefinitionToJSON(value['sessionDefinition']),
    };
}

